// Refund Policy Page Translations
export const refundPolicyTranslations = {
  en: {
    // Hero Section
    pageTitle: '📜 Refund Policy',
    pageSubtitle: 'At SubifyHub Team, customer satisfaction is our top priority. We are committed to providing high-quality service and support. In the rare case that you encounter any issues with your subscription, we offer clear and fair policies for replacements and refunds.',

    // Warranty Section
    warrantyCoverage: 'Warranty Coverage',
    replacementWarranty: 'Replacement Warranty',
    warranty: 'Warranty',
    warranties: [
      {
        id: 1,
        title: 'Monthly Accounts',
        duration: '25 Days',
        description: 'Monthly subscriptions come with a 25-day replacement warranty.',
        details: 'If you experience any issues with your monthly account within 25 days of purchase, we will provide a free replacement with a new account, ensuring no disruption to your service.',
      },
      {
        id: 2,
        title: 'Yearly Accounts',
        duration: '1 Year',
        description: 'Yearly subscriptions are covered by a full 1-year warranty.',
        details: 'If you face any technical issues during the year, we will either replace the account or resolve the problem, depending on the situation. A replacement will be provided within the warranty period.',
      },
    ],

    // Refund Process Section
    refundProcessTitle: 'How to Request a Refund or Replacement',
    refundProcess: [
      {
        step: 1,
        title: 'Contact Support',
        description: 'Reach out to our support team via WhatsApp with details of your issue',
      },
      {
        step: 2,
        title: 'Provide Evidence',
        description: 'Submit screenshots or error logs to help us understand the problem',
      },
      {
        step: 3,
        title: 'Assessment',
        description: 'Our team will assess the situation and determine eligibility',
      },
      {
        step: 4,
        title: 'Resolution',
        description: 'Receive a replacement account or refund within 3 business days',
      },
    ],

    // Refund Calculation Section
    refundCalculation: '💰 Refund Calculation',
    fullRefund: 'Full Refund:',
    fullRefundDesc: 'If the issue arises due to an error or failure on our platform, we will issue a full refund.',
    proRataTitle: 'Pro-Rata Refund Calculation:',
    proRataDesc: 'Refunds will be calculated based on the unused portion of your subscription.',
    proRataExample: 'Example:',
    proRataExampleText: 'If you used the account for 10 days out of 30 days, you will receive a refund for the remaining 20 days.',
    proRataNote: '* The refund will be processed after subtracting any applicable taxes or transaction fees.',

    // Eligibility Section
    refundEligibility: '✅ Refund Eligibility',
    eligibilityItems: [
      {
        eligible: true,
        text: 'Issues directly related to SubifyHub Team\'s services or technical malfunction',
      },
      {
        eligible: true,
        text: 'Problems occurring within the warranty period (25 days for monthly, 1 year for yearly)',
      },
      {
        eligible: true,
        text: 'Platform errors or failures on our end',
      },
      {
        eligible: false,
        text: 'Issues caused by external factors (payment issues, connectivity problems)',
      },
      {
        eligible: false,
        text: 'Incorrect setup or configuration by the customer',
      },
      {
        eligible: false,
        text: 'Problems with third-party services outside our control',
      },
    ],
    importantNote: 'Important:',
    importantNoteText: 'All refund requests must be made within the appropriate warranty period, and support documentation (such as screenshots or error logs) may be required.',

    // Processing Time Section
    processingTime: '⏱️ Refund Processing Time',
    processingTimeDesc: 'All refunds are processed within',
    businessDays: '3 business days',
    processingTimeDescCont: 'after approval. The time it takes for the refund to be credited to your account may vary depending on the payment method used.',
    processingBadge: '3 Business Days Processing',
    secureRefund: 'Secure Refund Process',

    // Exclusions Section
    refundExclusions: '⚠️ Refund Exclusions',
    exclusion1: 'Refunds will',
    exclusion1Not: 'not',
    exclusion1Text: 'be issued for issues caused by external factors such as local payment failures, internet connectivity issues, or problems with third-party services.',
    exclusion2: 'If you receive a replacement account and the issue persists, a refund may',
    exclusion2Not: 'not',
    exclusion2Text: 'be applicable unless the issue is unresolved by SubifyHub Team.',

    // Support Section
    needAssistance: '📞 Need Assistance?',
    supportDesc: 'If you experience any issues, please contact SubifyHub Team support immediately. Our support team will promptly assess the situation and help resolve your concerns.',
    contactSupport: 'Contact Support on WhatsApp',
  },
  fr: {
    // Hero Section
    pageTitle: '📜 Politique de Remboursement',
    pageSubtitle: 'Chez SubifyHub Team, la satisfaction client est notre priorité absolue. Nous nous engageons à fournir un service et un support de haute qualité. Dans le rare cas où vous rencontrez des problèmes avec votre abonnement, nous offrons des politiques claires et équitables pour les remplacements et les remboursements.',

    // Warranty Section
    warrantyCoverage: 'Couverture de Garantie',
    replacementWarranty: 'Garantie de Remplacement',
    warranty: 'Garantie',
    warranties: [
      {
        id: 1,
        title: 'Comptes Mensuels',
        duration: '25 Jours',
        description: 'Les abonnements mensuels sont accompagnés d\'une garantie de remplacement de 25 jours.',
        details: 'Si vous rencontrez des problèmes avec votre compte mensuel dans les 25 jours suivant l\'achat, nous fournirons un remplacement gratuit avec un nouveau compte, assurant aucune interruption de votre service.',
      },
      {
        id: 2,
        title: 'Comptes Annuels',
        duration: '1 An',
        description: 'Les abonnements annuels sont couverts par une garantie complète d\'1 an.',
        details: 'Si vous rencontrez des problèmes techniques au cours de l\'année, nous remplacerons le compte ou résoudrons le problème, selon la situation. Un remplacement sera fourni pendant la période de garantie.',
      },
    ],

    // Refund Process Section
    refundProcessTitle: 'Comment Demander un Remboursement ou un Remplacement',
    refundProcess: [
      {
        step: 1,
        title: 'Contacter le Support',
        description: 'Contactez notre équipe de support via WhatsApp avec les détails de votre problème',
      },
      {
        step: 2,
        title: 'Fournir des Preuves',
        description: 'Soumettez des captures d\'écran ou des journaux d\'erreurs pour nous aider à comprendre le problème',
      },
      {
        step: 3,
        title: 'Évaluation',
        description: 'Notre équipe évaluera la situation et déterminera l\'éligibilité',
      },
      {
        step: 4,
        title: 'Résolution',
        description: 'Recevez un compte de remplacement ou un remboursement sous 3 jours ouvrables',
      },
    ],

    // Refund Calculation Section
    refundCalculation: '💰 Calcul du Remboursement',
    fullRefund: 'Remboursement Complet :',
    fullRefundDesc: 'Si le problème survient en raison d\'une erreur ou d\'une défaillance de notre plateforme, nous effectuerons un remboursement complet.',
    proRataTitle: 'Calcul du Remboursement au Prorata :',
    proRataDesc: 'Les remboursements seront calculés en fonction de la partie non utilisée de votre abonnement.',
    proRataExample: 'Exemple :',
    proRataExampleText: 'Si vous avez utilisé le compte pendant 10 jours sur 30 jours, vous recevrez un remboursement pour les 20 jours restants.',
    proRataNote: '* Le remboursement sera traité après déduction des taxes ou frais de transaction applicables.',

    // Eligibility Section
    refundEligibility: '✅ Éligibilité au Remboursement',
    eligibilityItems: [
      {
        eligible: true,
        text: 'Problèmes directement liés aux services de SubifyHub Team ou dysfonctionnement technique',
      },
      {
        eligible: true,
        text: 'Problèmes survenant pendant la période de garantie (25 jours pour mensuel, 1 an pour annuel)',
      },
      {
        eligible: true,
        text: 'Erreurs ou défaillances de la plateforme de notre côté',
      },
      {
        eligible: false,
        text: 'Problèmes causés par des facteurs externes (problèmes de paiement, problèmes de connectivité)',
      },
      {
        eligible: false,
        text: 'Configuration incorrecte par le client',
      },
      {
        eligible: false,
        text: 'Problèmes avec des services tiers hors de notre contrôle',
      },
    ],
    importantNote: 'Important :',
    importantNoteText: 'Toutes les demandes de remboursement doivent être effectuées dans la période de garantie appropriée, et une documentation de support (comme des captures d\'écran ou des journaux d\'erreurs) peut être requise.',

    // Processing Time Section
    processingTime: '⏱️ Délai de Traitement du Remboursement',
    processingTimeDesc: 'Tous les remboursements sont traités sous',
    businessDays: '3 jours ouvrables',
    processingTimeDescCont: 'après approbation. Le temps nécessaire pour que le remboursement soit crédité sur votre compte peut varier selon la méthode de paiement utilisée.',
    processingBadge: 'Traitement sous 3 Jours Ouvrables',
    secureRefund: 'Processus de Remboursement Sécurisé',

    // Exclusions Section
    refundExclusions: '⚠️ Exclusions de Remboursement',
    exclusion1: 'Les remboursements ne seront',
    exclusion1Not: 'pas',
    exclusion1Text: 'accordés pour des problèmes causés par des facteurs externes tels que des échecs de paiement locaux, des problèmes de connectivité Internet ou des problèmes avec des services tiers.',
    exclusion2: 'Si vous recevez un compte de remplacement et que le problème persiste, un remboursement pourrait',
    exclusion2Not: 'ne pas',
    exclusion2Text: 'être applicable sauf si le problème n\'est pas résolu par SubifyHub Team.',

    // Support Section
    needAssistance: '📞 Besoin d\'Assistance ?',
    supportDesc: 'Si vous rencontrez des problèmes, veuillez contacter immédiatement le support de SubifyHub Team. Notre équipe de support évaluera rapidement la situation et vous aidera à résoudre vos préoccupations.',
    contactSupport: 'Contacter le Support sur WhatsApp',
  },
};

export const useRefundPolicyTranslations = (language = 'en') => {
  return refundPolicyTranslations[language] || refundPolicyTranslations['en'];
};
